import { Case, CaseType } from '@/@types/generated'
import { TagIcon } from 'lucide-react'
import { CaseTypesProvider, useCaseTypes } from '../hooks/case-types'
import SelectTypeButton from './SelectTypeButton'

interface CaseTypeButtonsProps {
  case: Case
  onChange: (v: CaseType | null, secondary?: boolean) => void
  disabled?: boolean
}

export default function CaseTypeButtons({
  case: { typePrimary, typeSecondary },
  onChange,
  disabled,
}: CaseTypeButtonsProps) {
  return (
    <CaseTypesProvider>
      <CaseTypeButtons.Button
        value={typePrimary || null}
        onChange={onChange}
        disabled={disabled}
      />

      <CaseTypeButtons.Button
        value={typeSecondary || null}
        onChange={onChange}
        disabled={disabled}
        secondary
      />
    </CaseTypesProvider>
  )
}

CaseTypeButtons.Button = function CaseTypeButton({
  value,
  onChange,
  disabled,
  secondary = false,
}: {
  value: CaseType | null
  secondary?: boolean
} & Pick<CaseTypeButtonsProps, 'onChange' | 'disabled'>) {
  // Hooks
  const { caseTypes } = useCaseTypes()

  return (
    <SelectTypeButton
      label={secondary ? 'Secondary Case Type' : 'Primary Case Type'}
      options={caseTypes}
      value={value}
      valueIcon={<TagIcon className="stroke-primary" />}
      disabled={disabled}
      onChange={(v) => onChange?.(v, secondary)}
    />
  )
}
